import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import PromotionsDashboard from './views/PromotionsDashboard.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/navigator',
            name: 'dashboard',
            meta: { 'package': 'navigator' },
            component: Dashboard
        },
        {
            path: '/inventory',
            name: 'inventory',
            meta: { 'package': 'navigator' },
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "inventory" */ './views/Inventory.vue')
        },
        {
            path: '/inventory/:department_id',
            name: 'inventory-department',
            meta: { 'package': 'navigator' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "inventory" */ './views/Inventory.vue')
        },
        {
            path: '/sales',
            name: 'sales',
            meta: { 'package': 'navigator' },
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "sales" */ './views/Sales.vue')
        },
        {
            path: '/sales/:department_id',
            name: 'sales-department',
            meta: { 'package': 'navigator' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "sales" */ './views/Sales.vue')
        },
        {
            path: '/suppliers',
            name: 'suppliers',
            meta: { 'package': 'navigator' },
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "suppliers" */ './views/Suppliers.vue')
        },
        {
            path: '/suppliers/:supplier_id',
            name: 'suppliers-supplier',
            meta: { 'package': 'navigator' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "suppliers" */ './views/Suppliers.vue')
        },
        {
            path: '/warehouse',
            name: 'warehouse',
            meta: { 'package': 'navigator' },
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "warehouse" */ './views/Warehouse.vue')
        },
        {
            path: '/warehouse/:distributor_id',
            name: 'warehouse-distributor',
            meta: { 'package': 'navigator' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "warehouse" */ './views/Warehouse.vue')
        },
        {
            path: '/distributors',
            name: 'distributors',
            meta: { 'package': 'navigator' },
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "distributors" */ './views/Distributors.vue')
        },
        {
            path: '/distributors/:distributor_id',
            name: 'distributors-distributor',
            meta: { 'package': 'navigator' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "distributors" */ './views/Distributors.vue')
        },
        {
            path: '/distributors/:distributor_id/department/:department_id',
            name: 'distributors-distributor-department',
            meta: { 'package': 'navigator' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "distributors" */ './views/Distributors.vue')
        },
        {
            path: '/manufacturers',
            name: 'manufacturers',
            meta: { 'package': 'navigator' },
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "manufacturers" */ './views/Manufacturers.vue')
        },
        {
            path: '/manufacturers/:department_id',
            name: 'manufacturers-department',
            meta: { 'package': 'navigator' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "manufacturers" */ './views/Manufacturers.vue')
        },
        {
            path: '/manufacturers/:department_id/:manufacturer_id',
            name: 'manufacturers-department-manufacturer',
            meta: { 'package': 'navigator' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "manufacturers" */ './views/Manufacturers.vue')
        },
        {
            path: '/item/:section/:product_id',
            name: 'item',
            meta: { 'package': 'navigator' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "item" */ './views/Item.vue')
        },
        {
            path: '/promotions',
            name: 'promotions-dashboard',
            meta: { 'package': 'promotions' },
            component: PromotionsDashboard
        },
        {
            path: '/promotionpacks',
            name: 'promotion-packs',
            meta: { 'package': 'promotions' },
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "promotion-packs" */ './views/PromotionPacks.vue')
        },
        {
            path: '/promotionpacks/:push_pack_id',
            name: 'promotion-detail',
            meta: { 'package': 'promotions' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "promotion-detail" */ './views/PromotionPacks.vue')
        },
        {
            path: '/marquees/:push_pack_id',
            name: 'marquees',
            meta: { 'package': 'promotions' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "marquees" */ './views/Marquees.vue')
        },
        {
            path: '/products/:push_pack_id',
            name: 'products',
            meta: { 'package': 'promotions' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "products" */ './views/Products.vue')
        },
        {
            path: '/email/:push_pack_id',
            name: 'email',
            meta: { 'package': 'promotions' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "email" */ './views/Email.vue')
        },
        {
            path: '/campaignreports',
            name: 'campaign-reports',
            meta: { 'package': 'promotions' },
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "campaign-reports" */ './views/CampaignReports.vue')
        },
        {
            path: '/campaignreports/:push_pack_id',
            name: 'campaign-report-detail',
            meta: { 'package': 'promotions' },
            props: true,
            // route level code-splitting
            // this generates a separate chunk for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "campaign-report-detail" */ './views/CampaignReports.vue')
        }
    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})
